module.exports = __webpack_public_path__ + "static/media/X.8c8afd44.svg";